import axios from "axios";

import { axiosClient } from "@/lib/api";

/**
 * Change the logged-in user's own PIN. Authenticated — the axios
 * interceptor injects the Bearer token. The server verifies the current PIN;
 * a wrong one counts toward the 5-attempt lockout and comes back as 400 with
 * the remaining attempts (not 401, which would read as session expiry).
 */
export async function changeOwnPin(
  currentPin: string,
  newPin: string,
): Promise<void> {
  await axiosClient({
    url: "/v1/auth/change-pin",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: { currentPin, newPin },
  });
}

/** How the change-PIN form should react to a failed attempt. */
export type ChangePinErrorResult =
  | { kind: "invalid"; attemptsRemaining?: number }
  | { kind: "locked" }
  | { kind: "generic" };

/** Map a change-PIN failure to UI behaviour. Pure so it can be unit-tested. */
export function interpretChangePinError(err: unknown): ChangePinErrorResult {
  if (axios.isAxiosError(err)) {
    const status = err.response?.status;
    const body = err.response?.data as
      | { code?: string; attemptsRemaining?: number }
      | undefined;

    if (body?.code === "ACCOUNT_LOCKED" || status === 423) {
      return { kind: "locked" };
    }
    if (body?.code === "INVALID_PIN") {
      return { kind: "invalid", attemptsRemaining: body?.attemptsRemaining };
    }
  }
  return { kind: "generic" };
}
